module.exports = __webpack_public_path__ + "5a705551f90a64e5aaf635861b5ceba5.svg";